export const CONVERT_TIME_UNIT_MODEL = "convert-time-unit";

const convertTimeUnitModel = {
  timeUnitName: "",
  payRates: []
};

export default convertTimeUnitModel;
